// lib/filters/parseBillLink

import parseLink from './parseLink'

var name = 'bill-info'
var link = 'bill-info'

export default {filters: { parseBillLink: parseLink(name, link) } }



/** WEBPACK FOOTER **
 ** ./src/js/lib/filters/parseBillLink.js
 **/